export default __webpack_public_path__ + "static/media/lat_long.b4e5e349.csv";